<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.reservation">
  <app-popup-header title="{{localService.languageContent.reservation.header}}" [isRefresh]="true"
    (onRefresh)="onLoad()"></app-popup-header>
  <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="activeSessions">
      <div class="row" *ngIf="activeSessions.sessions.length == 0">
        <div class="col-12" style="text-align:center;">
          <span>{{localService.languageContent.reservation.no_session_found}}</span>
        </div>
      </div>
      <div class="box" *ngFor="let item of activeSessions.sessions">
        <div class="row">
          <div class="col-4 en">
            <span>{{item.v1}}</span>
          </div>
          <div class="col-5">
            <span class="en">{{item.v5 | localDate}}</span>
          </div>
          <div class="col-3" style="text-align:right;">
            <button class="button_icon button_icon_color" *ngIf="!isSeatsLoaded(item.key)"
              (click)="onAction(3,item.key)">airline_seat_recline_normal</button>
            <button class="button_icon button_icon_color" *ngIf="!isBillsLoaded(item.key)"
              (click)="onAction(8,item.key)">receipt</button>
          </div>
        </div>
        <div class="row" *ngIf="item.v4 != ''">
          <div class="col-12">
            <span [ngClass]="item.v3 ? localService.getLanguageCode(item.v3) : 'en'">{{item.v4}}</span>
          </div>
        </div>
        <div class="row" *ngFor="let itemSub of onGetSeats(item.key);">
          <div class="col-3 en" style="text-align:right;">
            {{itemSub.v1}}
          </div>
          <div class="col-9">
            <app-seat-arrangements [seatsStatusAndTitle]="onGetSeatArrangementBySessionId(item.key,itemSub.key)"
              [seatTypeStr]="itemSub.v2"></app-seat-arrangements>
          </div>
        </div>
        <div class="row" *ngFor="let itemSub of onGetBills(item.key);">
          <div class="col-6 en">
            <span>{{itemSub.value}}</span>
          </div>
          <div class="col-6" style="text-align:right;">
            <i *ngIf="isAllowToEdit && billingId == itemSub.key" class="material-icons delete_icon icon_adjust"
              (click)="onDetachBill(item.key,itemSub.key)">cancel</i>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isAllowToEdit">
        <div class="col-md-6" style="width: 100%; text-align: center">
          <button type="button" style="width: 400px; margin: 5px;" class="btn btn-primary"
            (click)="onCheked(1)">{{localService.languageContent.reservation.attach_from_current_session}}</button>
        </div>
        <div class="col-md-6" style="width: 100%; text-align: center">
          <button type="button" style="width: 400px; margin: 5px;" class="btn btn-primary"
            (click)="onCheked(2)">{{localService.languageContent.reservation.attach_to_new_session}}</button>
        </div>
      </div>
    </div>
  </div>
</div>